import { __extends } from "tslib";
import { alCoerceString, alToBoolean, alToInteger, alToNumber } from '../runtime';
import { avm1BroadcastNativeEvent, avm1HasEventProperty, getAVM1Object, toTwipFloor, toTwipRound, away2avmDepth } from './AVM1Utils';
import { isNullOrUndefined, notImplemented, somewhatImplemented, warning, release, assert } from '@awayfl/swf-loader';
import { AVM1Rectangle, toAS3Rectangle } from './AVM1Rectangle';
import { AVM1Object } from '../runtime/AVM1Object';
import { AVM1PropertyDescriptor } from '../runtime/AVM1PropertyDescriptor';
import { BasicPartition } from '@awayjs/view';
import { AVM1Stage } from './AVM1Stage';
import { AVM1Transform } from './AVM1Transform';
import { convertToAS3Filters } from './AVM1Filters';
var AVM1SymbolBase = /** @class */ (function (_super) {
    __extends(AVM1SymbolBase, _super);
    function AVM1SymbolBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSwappedDepth = false;
        _this.dynamicallyCreated = false;
        _this._filterModels = [];
        _this.enabled = true;
        return _this;
    }
    //	these are used so that we do not rely on values
    //	coming from awayJS that might have float-issue:
    //private _xscale:number;
    //private _yscale:number;
    //private _rotation:number;
    AVM1SymbolBase.prototype.initAVM1SymbolInstance = function (context, awayObject) {
        //AVM1Object.call(this, context);
        this.constructorHasRun = true;
        this.avmType = 'symbol';
        this.scriptRefsToChilds = {};
        this._mouseListenerCount = 0;
        this._avm1Context = context;
        this._ownProperties = Object.create(null);
        this._prototype = null;
        var self = this;
        // Using IAVM1Callable here to avoid circular calls between AVM1Object and
        // AVM1Function during constructions.
        // TODO do we need to support __proto__ for all SWF versions?
        this._onClipEventsListeners = [];
        var getter = { alCall: function (thisArg, args) { return self.alPrototype; } };
        var setter = { alCall: function (thisArg, args) { self.alPrototype = args[0]; } };
        var desc = new AVM1PropertyDescriptor(128 /* ACCESSOR */ |
            2 /* DONT_DELETE */ |
            1 /* DONT_ENUM */, null, getter, setter);
        this.alSetOwnProperty('__proto__', desc);
        release || assert(awayObject);
        this.adaptee = awayObject;
        this.adaptee.partitionClass = BasicPartition;
        this.node = AVM1Stage.avmStage.pool.getNode(this.adaptee);
        var name = awayObject.name;
        var parent = this.get_parent();
        if (name && parent) {
            parent._addChildName(this, name);
        }
    };
    AVM1SymbolBase.prototype.bindEvents = function (events, autoUnbind) {
        if (autoUnbind === void 0) { autoUnbind = true; }
        this._events = events;
        var eventsMap = Object.create(null);
        this._eventsMap = eventsMap;
        this._eventsListeners = Object.create(null);
        this._eventHandlers = Object.create(null);
        var observer = this;
        var context = this.context;
        events.forEach(function (event) {
            // Normalization will always stay valid in a player instance, so we can safely modify
            // the event itself, here.
            var propertyName = event.propertyName = context.normalizeName(event.propertyName);
            eventsMap[propertyName] = event;
            //context.registerEventPropertyObserver(propertyName, observer);
            observer._updateEvent(event);
        });
    };
    AVM1SymbolBase.prototype.unbindEvents = function () {
        var events = this._events;
        var observer = this;
        var context = this.context;
        events.forEach(function (event) {
            context.unregisterEventPropertyObserver(event.propertyName, observer);
            observer._removeEventListener(event);
        });
        this._events = null;
        this._eventsMap = null;
        this._eventsListeners = null;
        this._eventHandlers = null;
    };
    AVM1SymbolBase.prototype._initEventsHandlers = function () {
        throw ('AVM1SymbolBase _initEventsHandlers must be overwritten');
    };
    AVM1SymbolBase.prototype.updateEventByPropName = function (eventName) {
        if (!this._eventsMap) {
            this._initEventsHandlers();
            console.log('no eventsmap set', this);
        }
        else if (this._eventsMap[eventName]) {
            this._updateEvent(this._eventsMap[eventName]);
        }
    };
    AVM1SymbolBase.prototype.updateAllEvents = function () {
        this._events.forEach(function (event) {
            this._updateEvent(event);
        }, this);
    };
    AVM1SymbolBase.prototype._updateEvent = function (event) {
        if (avm1HasEventProperty(this.context, this, event.propertyName)) {
            this._addEventListener(event);
        }
        else {
            this._removeEventListener(event);
        }
    };
    AVM1SymbolBase.prototype._addOnClipEventListener = function (event, callback, eventProps) {
        if (callback === void 0) { callback = null; }
        if (eventProps === void 0) { eventProps = null; }
        event.propertyName = this.context.normalizeName(event.propertyName);
        this._onClipEventsListeners.push({ event: event, callback: callback });
        if (this.enabled || !event.allowDisable)
            this.addEventListenerOnAdapter(event, callback, eventProps);
    };
    AVM1SymbolBase.prototype._addEventListener = function (event, callback) {
        if (callback === void 0) { callback = null; }
        var propertyName = this.context.normalizeName(event.propertyName);
        var listener = this._eventsListeners[propertyName];
        var myThis = this;
        if (!listener) {
            if (!callback) {
                listener = function avm1EventHandler() {
                    var args = null;
                    if (propertyName.toLowerCase() == 'onchanged') {
                        args = [myThis];
                    }
                    //var args = event.argsConverter ? event.argsConverter.apply(null, arguments) : null;
                    avm1BroadcastNativeEvent(this.context, this, propertyName, args); //args);
                }.bind(this);
            }
            else {
                listener = callback;
            }
            this._eventsListeners[propertyName] = listener;
            this._eventHandlers[propertyName] = event;
        }
        if (this.enabled || !event.allowDisable) {
            this.addEventListenerOnAdapter(event, listener);
        }
    };
    AVM1SymbolBase.prototype.addEventListenerOnAdapter = function (event, callback, eventProps) {
        if (eventProps === void 0) { eventProps = null; }
        if (event.stageEvent) {
            var avm1Handler = this.context.globals.Stage.avm1Handler;
            avm1Handler.addAVM1EventListener(this.adaptee, event.eventName, callback, eventProps);
        }
        else {
            this.adaptee.addEventListener(event.eventName, callback);
            this._updateMouseEnabled(event, true);
        }
    };
    AVM1SymbolBase.prototype.removeEventListenerOnAdapter = function (event, callback) {
        if (event.stageEvent) {
            var avm1Handler = this.context.globals.Stage.avm1Handler;
            if (avm1Handler)
                avm1Handler.removeAVM1EventListener(this.adaptee, event.eventName, callback);
        }
        else {
            this.adaptee.removeEventListener(event.eventName, callback);
            this._updateMouseEnabled(event, false);
        }
    };
    AVM1SymbolBase.prototype._updateMouseEnabled = function (event, enabled) {
        if (!this.adaptee.isAVMScene) {
            if (event.isMouse) {
                if (enabled) {
                    this._mouseListenerCount++;
                    this.adaptee.mouseEnabled = true;
                    this.adaptee.mouseChildren = false;
                }
                else {
                    this._mouseListenerCount--;
                    if (this._mouseListenerCount <= 0) {
                        this._mouseListenerCount = 0;
                        this.adaptee.mouseEnabled = false;
                        this.adaptee.mouseChildren = true;
                    }
                }
            }
        }
    };
    AVM1SymbolBase.prototype.freeFromScript = function () {
        _super.prototype.freeFromScript.call(this);
        this.enabled = true;
        this.adaptee.mouseEnabled = false;
        this.adaptee.mouseChildren = true;
        for (var key in this._eventsListeners) {
            this.removeEventListenerOnAdapter(this._eventHandlers[key], this._eventsListeners[key]);
        }
        this._eventsListeners = {};
        var cnt = this._onClipEventsListeners.length;
        while (cnt > 0) {
            cnt--;
            this.removeEventListenerOnAdapter(this._onClipEventsListeners[cnt].event, this._onClipEventsListeners[cnt].callback);
        }
        this._onClipEventsListeners = [];
        this._mouseListenerCount = 0;
    };
    AVM1SymbolBase.prototype._removeEventListener = function (event) {
        var propertyName = this.context.normalizeName(event.propertyName);
        var listener = this._eventsListeners[propertyName];
        if (listener) {
            this.removeEventListenerOnAdapter(event, listener);
            delete this._eventsListeners[propertyName];
        }
    };
    AVM1SymbolBase.prototype.onEventPropertyModified = function (propertyName) {
        propertyName = this.context.normalizeName(propertyName);
        var event = this._eventsMap[propertyName];
        this._updateEvent(event);
    };
    AVM1SymbolBase.prototype.getEnabled = function () {
        return this.enabled;
    };
    AVM1SymbolBase.prototype.setEnabled = function (value) {
        if (value == this.enabled)
            return;
        this.enabled = value;
        this.setEnabledListener(value);
    };
    AVM1SymbolBase.prototype.setEnabledListener = function (value) {
        if (value !== false && value !== 0) {
            for (var key in this._eventsListeners) {
                if (this._eventHandlers[key].allowDisable) {
                    this.addEventListenerOnAdapter(this._eventHandlers[key], this._eventsListeners[key]);
                }
            }
            for (var key in this._onClipEventsListeners) {
                if (this._onClipEventsListeners[key].event.allowDisable) {
                    this.addEventListenerOnAdapter(this._onClipEventsListeners[key].event, this._onClipEventsListeners[key].callback);
                }
            }
        }
        else {
            for (var key in this._eventsListeners) {
                if (this._eventHandlers[key].allowDisable) {
                    this.removeEventListenerOnAdapter(this._eventHandlers[key], this._eventsListeners[key]);
                }
            }
            for (var key in this._onClipEventsListeners) {
                if (this._onClipEventsListeners[key].event.allowDisable) {
                    this.removeEventListenerOnAdapter(this._onClipEventsListeners[key].event, this._onClipEventsListeners[key].callback);
                }
            }
        }
    };
    AVM1SymbolBase.prototype.get_alpha = function () {
        return this.adaptee.alpha * 100;
    };
    AVM1SymbolBase.prototype.set_alpha = function (value) {
        this._ctBlockedByScript = true;
        value = alToNumber(this.context, value);
        if (isNaN(value)) {
            return;
        }
        this.adaptee.alpha = value / 100;
    };
    AVM1SymbolBase.prototype.getBlendMode = function () {
        notImplemented('AVM1SymbolBase.getBlendMode');
        return ''; //this.adaptee.blendMode;
    };
    AVM1SymbolBase.prototype.setBlendMode = function (_value) {
        notImplemented('AVM1SymbolBase.setBlendMode');
        /*value = typeof value === 'number' ? BlendModesMap[value] : alCoerceString(this.context, value);
        this.adaptee.blendMode = value || null;*/
    };
    AVM1SymbolBase.prototype.getCacheAsBitmap = function () {
        return this.adaptee.cacheAsBitmap;
    };
    AVM1SymbolBase.prototype.setCacheAsBitmap = function (value) {
        value = alToBoolean(this.context, value);
        this.adaptee.cacheAsBitmap = value;
    };
    AVM1SymbolBase.prototype.getFilters = function () {
        notImplemented('AVM1SymbolBase.getFilters');
        return this._as2Filters;
    };
    AVM1SymbolBase.prototype.setFilters = function (value) {
        notImplemented('AVM1SymbolBase.setFilters');
        this._filterModels = convertToAS3Filters(this.context, value);
        this._as2Filters = value;
        //80pro this.adaptee.filters = convertToAS3Filters(this.context, value);
    };
    AVM1SymbolBase.prototype.get_focusrect = function () {
        notImplemented('AVM1SymbolBase.setOpaqueBackground');
        return false; //this.adaptee.focusRect || false; // suppressing null
    };
    AVM1SymbolBase.prototype.set_focusrect = function (value) {
        notImplemented('AVM1SymbolBase.setOpaqueBackground');
        /*
        value = alToBoolean(this.context, value);
        this.adaptee.focusRect = value;
        */
    };
    AVM1SymbolBase.prototype.get_height = function () {
        var box = AVM1Stage.avmStage.pickGroup
            .getBoundsPicker(this.node.partition)
            .getBoxBounds(AVM1Stage.avmStage.pool.getNode(this.adaptee.parent || AVM1Stage.avmStage.root));
        return (box == null) ? 0 : toTwipFloor(box.height);
    };
    AVM1SymbolBase.prototype.set_height = function (value) {
        value = toTwipFloor(alToNumber(this.context, value));
        this._blockedByScript = true;
        if (isNaN(value))
            return;
        AVM1Stage.avmStage.pickGroup
            .getBoundsPicker(this.node.partition).height = value;
    };
    AVM1SymbolBase.prototype.get_highquality = function () {
        switch (this.get_quality()) {
            case 'BEST':
                return 2;
            case 'HIGH':
                return 1;
            default: // case 'LOW':
                return 0;
        }
    };
    AVM1SymbolBase.prototype.set_highquality = function (value) {
        var quality;
        switch (alToInteger(this.context, value)) {
            case 2:
                quality = 'BEST';
                break;
            case 1:
                quality = 'HIGH';
                break;
            default:
                quality = 'LOW';
                break;
        }
        this.set_quality(quality);
    };
    AVM1SymbolBase.prototype.getMenu = function () {
        notImplemented('AVM1SymbolBase.getMenu');
        // return this.adaptee.contextMenu;
    };
    AVM1SymbolBase.prototype.setMenu = function (value) {
        notImplemented('AVM1SymbolBase.setMenu');
        // this.adaptee.contextMenu = value;
    };
    AVM1SymbolBase.prototype.get_name = function () {
        return this.adaptee ? this.adaptee.name : undefined;
    };
    AVM1SymbolBase.prototype.set_name = function (value) {
        value = alCoerceString(this.context, value);
        var oldName = this.adaptee.name;
        this.adaptee.name = value;
        var avmParent = this.get_parent();
        if (avmParent) {
            avmParent.registerScriptObject(this.adaptee);
            avmParent._updateChildName(this, oldName, value);
        }
    };
    AVM1SymbolBase.prototype.get_parent = function () {
        var parent = getAVM1Object(this.adaptee.parent, this.context);
        // In AVM1, the _parent property is `undefined`, not `null` if the element has no parent.
        return parent || undefined;
    };
    AVM1SymbolBase.prototype.set_parent = function (value) {
        notImplemented('AVM1SymbolBase.set_parent');
    };
    AVM1SymbolBase.prototype.getOpaqueBackground = function () {
        notImplemented('AVM1SymbolBase.getOpaqueBackground');
        return 0; //this.adaptee.opaqueBackground;
    };
    AVM1SymbolBase.prototype.setOpaqueBackground = function (value) {
        notImplemented('AVM1SymbolBase.setOpaqueBackground');
        /*
        if (isNullOrUndefined(value)) {
            this.adaptee.opaqueBackground = null;
        } else {
            this.adaptee.opaqueBackground = alToInt32(this.context, value);
        }
        */
    };
    AVM1SymbolBase.prototype.get_quality = function () {
        somewhatImplemented('AVM1SymbolBase.get_quality');
        return 'HIGH';
    };
    AVM1SymbolBase.prototype.set_quality = function (value) {
        somewhatImplemented('AVM1SymbolBase.set_quality');
    };
    AVM1SymbolBase.prototype.set_root = function (value) {
        notImplemented('AVM1SymbolBase.set_root');
    };
    AVM1SymbolBase.prototype.get_root = function () {
        var awayObject = this.adaptee;
        var avmObject = null;
        while (awayObject && !awayObject.isAVMScene) {
            avmObject = getAVM1Object(awayObject, this.context);
            if (avmObject && avmObject.get_lockroot()) {
                return avmObject;
            }
            awayObject = awayObject.parent;
        }
        if (!awayObject) {
            return undefined;
        }
        return getAVM1Object(awayObject, this.context);
    };
    AVM1SymbolBase.prototype.get_rotation = function () {
        var value = Math.round(this.adaptee.rotationZ);
        while (value > 180) {
            value -= 360;
        }
        while (value < -180) {
            value += 360;
        }
        return value;
    };
    AVM1SymbolBase.prototype.set_rotation = function (value) {
        value = alToNumber(this.context, value);
        this._blockedByScript = true;
        if (isNaN(value)) {
            return;
        }
        this.adaptee.rotationZ = value;
    };
    AVM1SymbolBase.prototype.getScale9Grid = function () {
        return AVM1Rectangle.fromAS3Rectangle(this.context, this.adaptee.scale9Grid);
    };
    AVM1SymbolBase.prototype.setScale9Grid = function (value) {
        this.adaptee.scale9Grid = isNullOrUndefined(value) ? null : toAS3Rectangle(value);
    };
    AVM1SymbolBase.prototype.getScrollRect = function () {
        return AVM1Rectangle.fromAS3Rectangle(this.context, this.adaptee.scrollRect);
    };
    AVM1SymbolBase.prototype.setScrollRect = function (value) {
        this.adaptee.scrollRect = isNullOrUndefined(value) ? null : toAS3Rectangle(value);
    };
    AVM1SymbolBase.prototype.get_soundbuftime = function () {
        notImplemented('AVM1SymbolBase.get_soundbuftime');
        return 0;
    };
    AVM1SymbolBase.prototype.set_soundbuftime = function (value) {
        notImplemented('AVM1SymbolBase.set_soundbuftime');
    };
    AVM1SymbolBase.prototype.getTabEnabled = function () {
        return this.adaptee ? this.adaptee.tabEnabled : false;
    };
    AVM1SymbolBase.prototype.setTabEnabled = function (value) {
        if (!this.adaptee)
            return;
        this.adaptee.tabEnabled = value;
    };
    AVM1SymbolBase.prototype.getTabIndex = function () {
        return this.adaptee.tabIndex;
    };
    AVM1SymbolBase.prototype.setTabIndex = function (value) {
        this.adaptee.tabIndex = value;
    };
    AVM1SymbolBase.prototype.get_target = function () {
        var awayObject = this.adaptee;
        if (awayObject === awayObject.root) {
            return '/';
        }
        var path = '';
        do {
            if (isNullOrUndefined(awayObject)) {
                warning('AVM1SymbolBase.get_target returns undefined');
                return undefined; // something went wrong
            }
            path = '/' + awayObject.name + path;
            awayObject = awayObject.parent;
        } while (awayObject && !awayObject.isAVMScene);
        return path;
    };
    // transform is only available in FP8
    AVM1SymbolBase.prototype.getTransform = function () {
        if (this.context.swfVersion < 8) {
            // special case: transform used as var name in FP<8
            return this['transformPreFP8'];
        }
        if (!this._avmTransform) {
            this._avmTransform = this.context.globals.Transform.alConstruct([this]);
        }
        return this._avmTransform;
    };
    AVM1SymbolBase.prototype.setTransform = function (value) {
        if (this.context.swfVersion < 8) {
            // special case: transform used as var name in FP<8
            this['transformPreFP8'] = value;
            return;
        }
        if (!(value instanceof AVM1Transform)) {
            return;
        }
        console.log('not implemented: AVM1SymbolBase.setTransform');
        //this.adaptee.transform = as3Transform;
    };
    AVM1SymbolBase.prototype.get_visible = function () {
        return this.adaptee.visible;
    };
    AVM1SymbolBase.prototype.set_visible = function (value) {
        this._visibilityByScript = true;
        value = alToBoolean(this.context, value);
        this.adaptee.visible = value;
    };
    AVM1SymbolBase.prototype.get_url = function () {
        return this.adaptee.assetNamespace;
    };
    AVM1SymbolBase.prototype.get_width = function () {
        var box = AVM1Stage.avmStage.pickGroup
            .getBoundsPicker(this.node.partition)
            .getBoxBounds(AVM1Stage.avmStage.pool.getNode(this.adaptee.parent || AVM1Stage.avmStage.root));
        return (box == null) ? 0 : toTwipRound(box.width);
    };
    AVM1SymbolBase.prototype.set_width = function (value) {
        value = toTwipRound(alToNumber(this.context, value));
        this._blockedByScript = true;
        if (isNaN(value))
            return;
        AVM1Stage.avmStage.pickGroup
            .getBoundsPicker(this.node.partition).width = value;
    };
    AVM1SymbolBase.prototype.get_x = function () {
        return toTwipFloor(this.adaptee.x);
    };
    AVM1SymbolBase.prototype.set_x = function (value) {
        value = toTwipFloor(alToNumber(this.context, value));
        this._blockedByScript = true;
        if (isNaN(value)) {
            return;
        }
        this.adaptee.x = value;
    };
    AVM1SymbolBase.prototype.get_xmouse = function () {
        return toTwipFloor(AVM1Stage.avmStage.getLocalMouseX(this.node));
    };
    AVM1SymbolBase.prototype.get_xscale = function () {
        return this.adaptee.scaleX * 100;
    };
    AVM1SymbolBase.prototype.set_xscale = function (value) {
        value = alToNumber(this.context, value);
        this._blockedByScript = true;
        if (isNaN(value)) {
            return;
        }
        this.adaptee.scaleX = value / 100;
    };
    AVM1SymbolBase.prototype.get_y = function () {
        return toTwipFloor(this.adaptee.y);
    };
    AVM1SymbolBase.prototype.set_y = function (value) {
        value = toTwipFloor(alToNumber(this.context, value));
        this._blockedByScript = true;
        if (isNaN(value)) {
            return;
        }
        this.adaptee.y = value;
    };
    AVM1SymbolBase.prototype.get_ymouse = function () {
        return toTwipFloor(AVM1Stage.avmStage.getLocalMouseY(this.node));
    };
    AVM1SymbolBase.prototype.get_yscale = function () {
        return this.adaptee.scaleY * 100;
    };
    AVM1SymbolBase.prototype.set_yscale = function (value) {
        value = alToNumber(this.context, value);
        this._blockedByScript = true;
        if (isNaN(value)) {
            return;
        }
        this.adaptee.scaleY = value / 100;
    };
    AVM1SymbolBase.prototype.getDepth = function () {
        if (this.protoTypeChanged)
            return null;
        return away2avmDepth(this.adaptee._avmDepthID);
    };
    AVM1SymbolBase.prototype.toString = function () {
        var mc = this.adaptee;
        var names = [];
        while (mc) {
            if (mc.isAVMScene) {
                names.push('_level0');
                mc = null;
            }
            else {
                names.push(mc.name);
                mc = mc.parent;
            }
        }
        var i = names.length;
        var mc_path = '';
        while (i > 0) {
            i--;
            mc_path += names[i];
            if (i > 0)
                mc_path += '.';
        }
        //console.log(mc_path);
        return mc_path;
    };
    return AVM1SymbolBase;
}(AVM1Object));
export { AVM1SymbolBase };
